import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import { IoChatbubblesOutline } from "react-icons/io5";

import "./navbar.css";
import lovingLogo from "../../assets/loving-logo.png";

const HomeNavbar = ({ isAuthenticated, handleLogout, toggleSidebar, openAddChat, showSidebar }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isRegisterPage = location.pathname === "/register";
  const isLoginPage = location.pathname === "/login";
  
  const [userName, setUserName] = useState(null);

  useEffect(() => {
    // Get userName from localStorage when authenticated
    if (isAuthenticated) {
      const storedUserName = localStorage.getItem("userName");
      setUserName(storedUserName);
    } else {
      setUserName(null); // Reset when logged out
    }
  }, [isAuthenticated]);

  // Open Add Chat (Redirect to login if not authenticated)
  const handleAddChat = () => {
    if (isAuthenticated) {
      // Your existing functionality when the user is authenticated
      console.log("User is authenticated. Open Add Chat Modal or Page.");
      openAddChat(); // You can call the existing function or any action for adding a chat here
    } else {
      navigate("/login"); // Redirect to login page if unauthenticated
    }
  };

  return (
    <header className="navbar-container">
      <nav className="navbar">
        {/* Left: Sidebar Toggle (Only Show if Authenticated) */}
        {isAuthenticated && (
          <div className="navbar-section navbar-left">
            <button className="menu-button" onClick={toggleSidebar}>
              {showSidebar ? (
                <FaTimes size={20} color="#000" />
              ) : (
                <FaBars size={20} color="#000" />
              )}
            </button>
          </div>
        )}


        {/* Center: Logo */}
        <div className="navbar-section navbar-center">
          <img src={lovingLogo} alt="Loving Logo" className="navbar-logo" />
        </div>

        <div className="navbar-section navbar-right">
          {/* Add Chat Button (Only Show if Authenticated) */}
        {isAuthenticated && (
          <button className="add-chat-navbar-button" onClick={handleAddChat}>
            <IoChatbubblesOutline size={20} color="#ffffff" />
          </button>
        )}
          {/* Authenticated: Show Username & Logout */}
          {!isAuthenticated && !isRegisterPage && !isLoginPage && (
            <div className="auth-buttons">
      <Link to="/login" className="navbar-button login">
        Login
      </Link>
    </div>
  )}
        </div>
      </nav>
    </header>
  );
};

export default HomeNavbar;
